var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-row"},[_c('div',{staticClass:"detailtitle"},[_c('b',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }